var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFastDonate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 174.5 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#FF9000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.56,17.64A52.93,52.93,0,1,0,85.9,121.22a10.12,10.12,0,0,1-5.71-5.08c-1.67-3.35-.87-7.14,2.15-10.15l.23-.23L123.32,74.6c.1-1.34.17-2.68.17-4A52.92,52.92,0,0,0,70.56,17.64Zm5.88,82v6.2H70.56V100A40.74,40.74,0,0,1,52.92,95.7L55.6,86c5.62,2.18,13.11,4.49,19,3.17,6.76-1.53,8.15-8.48.67-11.82C69.76,74.83,53,72.65,53,58.32c0-8,6.11-15.19,17.54-16.76V35.28h5.88v6A54.09,54.09,0,0,1,90.8,43.74l-2.12,9.69c-4.52-1.59-9.51-3-14.36-2.74-8.76.52-9.53,8.1-3.42,11.27C81,66.69,94.09,70.2,94.09,82.81,94.1,92.92,86.18,98.29,76.44,99.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.42,121.7H99.54A58.79,58.79,0,1,1,129.35,70l11.17-8.54a70.57,70.57,0,1,0-38,72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.17,111.49a3.94,3.94,0,0,0-3.68-2.86H145.94l15.95-47.87c.41-1.64,0-3.68-1.63-4.5-1.64-1.23-3.28-.82-4.91,0L85.8,109.45c-1.23,1.23-2,2.86-1.23,4.5a4.91,4.91,0,0,0,4.09,2.86h24.55l-16,47.87c-.41,1.64,0,3.68,1.64,4.5a3.13,3.13,0,0,0,2,.82,5.83,5.83,0,0,0,2.46-.82L172.94,116C174.17,114.77,175,113.13,174.17,111.49Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastDonate);
export default __webpack_public_path__ + "static/media/fast_donate.b866de5bc1c527223c00f38966e4c991.svg";
export { ForwardRef as ReactComponent };